import React from "react";

function ContactUs() {
  return (
    <section className="hm-block hm-alt hm-contact" id="hm-contact">
      <div className="hm-wrap">
        <div className="hm-center">
          <span className="hm-eyebrow hm-reveal">Contact us</span>
          <h2 className="hm-reveal">Come say hello</h2>
        </div>
        <div className="hm-grid">
          <div className="hm-reveal">
            <div className="hm-info">
              <span className="hm-info-ico">
                <i className="now-ui-icons location_pin" />
              </span>
              <div>
                <b>Registered Address</b>
                <span>
                  Sarjapur Outer Ring Road Bengali Association
                  <br />
                  Flat #108, Block #16, Suncity Apartments,
                  <br />
                  Sarjapur Road, Bangalore, Karnataka 560102, India
                </span>
              </div>
            </div>
          </div>
          <div className="hm-reveal">
            <div className="hm-info">
              <span className="hm-info-ico">
                <i className="now-ui-icons tech_mobile" />
              </span>
              <div>
                <b>Give us a ring</b>
                <span>+91 84317 60322</span>
              </div>
            </div>
            <div className="hm-info">
              <span className="hm-info-ico">
                <i className="now-ui-icons ui-1_email-85" />
              </span>
              <div>
                <b>Drop an email</b>
                <span>contact@sorrba.org</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
